<template>
  <v-dialog
    v-model="statusModal"
    width="637px"
    content-class="v-dialog__form">
    <v-card>
      <v-card-title>
        <div class="d-flex align-center">
          Update App Access
        </div>
        <v-icon
          color="#fff"
          @click="statusModal = false">
          mdi-close
        </v-icon>
      </v-card-title>
      <v-card-text>
        <p>
          Email: {{ userEmail }}
        </p>
        <p>
          App Access: {{ currentAppAccess }}
        </p>
        <v-radio-group v-model="selectedAccess">
          <v-radio
            label="Enabled"
            value="true"
            color="lightBlue" />
          <v-radio
            label="Disabled"
            value="false"
            color="lightBlue" />
        </v-radio-group>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="lightBlue"
          @click="toggleAppAccess">
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'AppAccessModal',
  props: {
    userAttributes: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      statusModal: false,
      selectedAccess: '',
    };
  },
  computed: {
    currentAppAccess() {
      const appAccess = this.userAttributes
      && this.userAttributes.attributes
      && this.userAttributes.attributes.find(attribute => attribute.name === 'custom:badge_scanner_access')
      && this.userAttributes.attributes.find(attribute => attribute.name === 'custom:badge_scanner_access').value;
      return appAccess === 'true' ? 'true' : 'false';
    },
    userEmail() {
      const email = this.userAttributes
      && this.userAttributes.attributes
      && this.userAttributes.attributes.find(attribute => attribute.name === 'email')
      && this.userAttributes.attributes.find(attribute => attribute.name === 'email').value;
      return email;
    },
  },
  methods: {
    showModal() {
      this.$nextTick(() => {
        this.statusModal = true;
        this.selectedAccess = this.currentAppAccess;
      });
    },
    toggleAppAccess() {
      this.$emit('toggleAppAccess', this.userEmail, this.selectedAccess);
      this.statusModal = false;
    },
  },
};
</script>